import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Margin from "Components/Stats/Margin";
import { useFetchGet } from "Services/api";
import { getChartSignedStatusData } from "Components/Stats/Data/Utilisateurs/Charte";
import NivoPie from "Components/Stats/Charts/NivoPie";

/**
 * Graphique des utilisateurs par role (étudiants | alumni)
 */
const UsersByCharterSigned = (props) => {
  // Acceptation de la charte RéseauPro ou non par les utilisateurs
  const [chartSignedStatus, setChartSignedStatus] = useState([]);

  const usersRolesCount = useFetchGet(
    "/users/stats/count_charter_signed",
    props.auth.token
  );

  /**
   * Mise à jour des données du graphique
   */
  const updateUserCount = () => {
    setChartSignedStatus(getChartSignedStatusData(usersRolesCount.data));
  };

  useEffect(() => {
    if (usersRolesCount.loaded) {
      updateUserCount();
    }
  }, [usersRolesCount.loaded]);

  /* Répartition des utilisateurs par role : {étudiants | alumni} */
  return (
    <>
      <NivoPie
        data={chartSignedStatus}
        title={`Utilisateurs ayant validé ou refusé la charte Réseau Pro à ce jour dans l'université ${props.universityName}`}
        colors="pastel2"
      />
      <Margin position="bottom" size="" />
    </>
  );
};

UsersByCharterSigned.propTypes = {
  //? Redux states
  users: PropTypes.any,
  auth: PropTypes.any,

  //? Props
  universityName: PropTypes.string,
};

const mapStateToProps = (state) => ({
  users: state.users,
  auth: state.auth,
});

export default connect(mapStateToProps)(UsersByCharterSigned);
